import * as React from 'react';
import type { CSSProperties } from 'react';

import { Pill } from '@coursera/coursera-ui';

import uuid from 'bundles/common/utils/uuid';

import 'css!./__styles__/PillList';

export type Props = {
  className?: string;
  items?: Array<string>;
  style?: CSSProperties;
} & React.HTMLAttributes<HTMLElement>;

export const PillList = ({
  items,
  // Often used for PII, presume as much and by default hide from fullstory, but allow overriding by caller.
  className = 'pii-hide fs-exclude',
  style = {},
  ...htmlProps
}: Props) => {
  const classNames = ['rc-PillList', className].filter((cn) => cn).join(' ');
  return items ? (
    <ul className={classNames} style={style} {...htmlProps}>
      {items.map((item) => (
        // Possible that `items` are not unique. Lower chance of key collision to pretty much 0.
        <Pill tag="li" key={`${item}_${uuid()}`} label={item} rootClassName="pill-list-item" />
      ))}
    </ul>
  ) : null;
};

export default PillList;
